import { Observable } from 'rxjs';

export interface ISettingsStore {
  getSetting$(key: string): Observable<string | null>;
  setSetting$(settingKey: string, value: string): Observable<boolean>;
}
